import {GoogleAdsPage} from 'src/components/googleAds/page/Page';
import {GridType} from 'src/enums/GridType';
import {useGGradeRefresh} from 'src/hooks/google/useGGradeRefresh';

export const GradeRefresh = (): JSX.Element => {
  useGGradeRefresh();

  return <GoogleAdsPage gridType={GridType.TAB}><></></GoogleAdsPage>;
};
